import React, { useEffect, useState } from "react";
import { Col, Nav, Row, Spinner, Tab } from "react-bootstrap";
import './style.scss';
import MonthlyTab from "./monthlyTab/page";
import AnnualyTab from "./annualyTab/page";
import { useDispatch, useSelector } from "react-redux";
import { getAllPlans } from "../../../../data/redux/pricing/_pricingAction";
import { getUserProfile } from "../../../../data/redux/user/_userAction";
import { getStorageItem, setStorageItem } from "../../../../../services/storage.service";

const PlanPricingTab = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(true);

  const userDetail: any = getStorageItem("userData") || null;
  const userData = userDetail !== null ? JSON.parse(userDetail) : null;
  const planPermission = userData?.plan_permissions;

  const pricingData = useSelector((state: any) => state?.pricing);
  const plans = pricingData?.planList || [];


  useEffect(() => {
    console.log("plan list page ====> ",);
    // fetchUserDetails();
    // dispatch(getAllPlans({}));
    const fetchData = async () => {
      setLoading(true);

      try {
        // Artificial delay + fetch plans
        await new Promise(resolve => setTimeout(resolve, 800)); // 600ms delay
        await dispatch(getAllPlans({}));

        // Artificial delay + fetch user profile
        await new Promise(resolve => setTimeout(resolve, 800)); // 800ms delay
        await fetchUserDetails();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const fetchUserDetails = async () => {
    try {
      const response: any = await dispatch(getUserProfile({}));
      const userDetails = response?.payload || response;

      if (userDetails) {
        if (planPermission?.plan_name.toLowerCase() !== userDetails?.plan_permissions?.plan_name.toLowerCase()) {
          setStorageItem("userData", JSON.stringify(userDetails));
        }
      }
    } catch (err) {
      console.error("Failed to fetch user details:", err);
    }
  };

  // Filter plans by type
  const monthlyPlans = plans.filter((plan: any) => plan.type === "monthly");
  const yearlyPlans = plans.filter((plan: any) => plan.type === "yearly");

  // Show loading spinner while fetching
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-50">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading plans...</span>
        </Spinner>
        <span className="ms-3 fs-5 text-muted">Loading your plans...</span>
      </div>
    );
  }


  return (
    <div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="Monthly">
        <Row>
          <Col sm={12}>
            <div className="d-flex justify-content-center ">
              <Nav variant="pills" className="mb-5 align-items-center justify-content-center position-relative">
                <Nav.Item>
                  <Nav.Link eventKey="Monthly">Monthly billing</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Annual">Annual billing</Nav.Link>
                </Nav.Item>
                <span className="saveText">Save 15% Off</span>
              </Nav>
            </div>
          </Col>
          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey="Monthly">
                <MonthlyTab plans={monthlyPlans} />
              </Tab.Pane>
              <Tab.Pane eventKey="Annual">
                <AnnualyTab plans={yearlyPlans} />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default PlanPricingTab;
